import { render, staticRenderFns } from "./sendcoupon.vue?vue&type=template&id=c55f0dfe&scoped=true"
import script from "./sendcoupon.vue?vue&type=script&lang=js"
export * from "./sendcoupon.vue?vue&type=script&lang=js"
import style0 from "./sendcoupon.vue?vue&type=style&index=0&id=c55f0dfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55f0dfe",
  null
  
)

export default component.exports